export function getExperiment(experiment) {
	if (typeof window === 'undefined') return undefined;

	var localStorageValue = window.localStorage.getItem(experiment);
	return localStorageValue || window[experiment];
}
